<div class="px-8 py-10">
  @switch (verificationStatus()) {
    @case ("success") {
      <div class="">
        <div class="flex items-center justify-center mx-auto text-tw-primary">
          <svg-icon
            src="assets/svgs/account_verified_icon.svg"
            [svgStyle]="{ 'width.px': 60, 'height.px': 60 }"
            [ngClass]="{
              '[&_svg]:!w-11  [&_svg]:!h-11 md:[&_svg]:!w-[60px] md:[&_svg]:!h-[60px]': true,
            }"
          ></svg-icon>
        </div>

        <div class="flex flex-col items-center pt-8 text-center">
          <h5
            class="text-base font-semibold md:text-lg lg:text-2xl text-tw-text-color"
          >
            Email Verification Successful
          </h5>

          <div class="pt-2 text-sm font-semibold text-center">
            <p class="px-4 text-xs lg:text-sm text-tw-text-color-accent">
              Your account has successfully been verified. Please click the
              button below to login to your account.
            </p>
          </div>

          <!-- <div class="text-center text-lg pt-8">
            <button
              *ngIf="verifyEmailResponse.isSuccess() || true"
              nz-button
              class=""
              nzSize="large"
              nzType="primary"
              type="button"
              [disabled]="verifyEmailResponse.isPending()"
              (click)="switchToLogin()"
            >
              Login to your Account
            </button>
          </div> -->
        </div>
      </div>
    }
    @case ("failure") {
      <app-email-verification-failed
        [email]="emailSignal()"
      ></app-email-verification-failed>
    }
    @default {
      <div class="">
        <div
          [ngClass]="{ 'relative [&>*]:h-[100px] [&>*]:block': true }"
          *ngIf="
            !verifyEmailResponse.isError() && !verifyEmailResponse.isSuccess()
          "
        >
          <!-- *ngIf="!verifyEmailResponse.isError() && !verifyEmailResponse.isSuccess()" -->
          <ngx-spinner
            bdColor="rgba(0, 0, 0, 0)"
            size="large"
            color="#079A3D"
            type="ball-elastic-dots"
            [fullScreen]="false"
          >
          </ngx-spinner>
        </div>

        <div class="flex flex-col items-center pt-8 text-center">
          <h5 class="text-xl font-medium text-tw-text-color">
            Verifying email. Please wait...
          </h5>

          <div class="pt-2 text-sm font-semibold text-center">
            <p class="text-tw-text-color-accent">
              Your email is currently being verified. Stay put...
            </p>
          </div>

          <!-- <div class="text-center text-[#5D5E5E] text-lg lg:pt-8">
            <button
              nz-button
              class=""
              nzSize="large"
              nzType="primary"
              type="button"
              [disabled]="true"
              (click)="switchToLogin()"
            >
              Login to your Account
            </button>
          </div> -->
        </div>
      </div>
    }
  }
</div>
